import { useSelector } from "react-redux";
import { Advisor } from "../../../components/DataCollection/Advisor/Advisor";
import { selectUserData } from "../../../features/userSlice";
import { CheckPermissions } from "../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import Page404 from "../../../components/Page404/Page403";

export const AdvisorScreen = () => {
  const userData = useSelector(selectUserData);
  const hasPermission = CheckPermissions(
    userData?.data?.products?.data_collection,
    "businesse_advisor",
    "view_advisor_maps",
  );
  //let react_env = import.meta.env.VITE_ENV;
  return <div>{!hasPermission ? <Page404 /> : <Advisor />}</div>;
};
